"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useResponsiveProps = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _react = require("react");

var ScreenSizes = _interopRequireWildcard(require("../constants/layout/ScreenSizes"));

var _useScreenSize = require("./useScreenSize");

var _useDeviceSize = require("./useDeviceSize");

var sizes = Object.values(ScreenSizes);

var getNextScreenSize = function getNextScreenSize(size) {
  if (size === ScreenSizes.XS) {
    return null;
  }

  return sizes[sizes.indexOf(size) - 1];
};

var useResponsiveProps = function useResponsiveProps(props) {
  var useDevice = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var deviceSize = (0, _useDeviceSize.useDeviceSize)();
  var windowSize = (0, _useScreenSize.useScreenSize)();
  var screenSize = useDevice ? deviceSize : windowSize;
  return (0, _react.useMemo)(function () {
    return Object.keys(props).reduce(function (acc, key) {
      var breakpoint = screenSize;

      while (!acc.hasOwnProperty(key)) {
        if (breakpoint === null || (0, _typeof2.default)(props[key]) !== 'object') {
          break;
        } else if (props[key].hasOwnProperty(breakpoint)) {
          acc[key] = props[key][breakpoint];
        } else {
          breakpoint = getNextScreenSize(breakpoint);
        }
      }

      return acc;
    }, {});
  }, [screenSize, props]);
};

exports.useResponsiveProps = useResponsiveProps;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/hooks/useResponsiveProps.js
// module id = 290
// module chunks = 209 210 211 212